<ng-container *ngIf="rangeQuickSelector">
  <ng-container *ngTemplateOutlet="rangeQuickSelector"></ng-container>
</ng-container>

<div *ngIf="extraFooter" class="phx-date-picker-footer-extra">
    <ng-container *ngIf="extraFooterType === 'refType'">
      <ng-container *ngTemplateOutlet="$any(extraFooter)"></ng-container>
    </ng-container>
    <ng-container *ngIf="extraFooterType === 'stringType'">
      <span [innerHTML]="extraFooter"></span>
    </ng-container>
</div>

<div *ngIf="selectedDateLabels?.from &&
    (showSelectedDateLabels ||
    !hideClearButton && !showResetButton ||
    showResetButton && isNonDefaultRangeSelected)"
  class="phx-date-picker-footer-main">
  <div *ngIf="showSelectedDateLabels" class="phx-date-picker-footer-selections">
    <span class="phx-date-picker-footer-from">{{ selectedDateLabels.from }}</span>
    <span *ngIf="selectedDateLabels.to" class="phx-date-picker-footer-to">&nbsp;-&nbsp;{{ selectedDateLabels.to }}</span>
  </div>
  <ng-container *ngIf="!hideClearButton && !showResetButton">
    <i *ngIf="showSelectedDateLabels" phx-icon [phxIcon]="Bullet20Icon"></i>
    <a
      class="phx-date-picker-footer-action-btn"
      type="button"
      role="button"
      [class.phx-date-picker-footer-disabled]="clearDisabled"
      (click)="clearDisabled ? null : this.onClear.emit()"
      (keydown)="clearDisabled ? null : onKeydown($event)"
      phxFocusableItem
    >
      {{ 'Clear' | phxTranslate }}
    </a>
  </ng-container>
  <!-- have precedence over clear btn -->
  <ng-container *ngIf="isNonDefaultRangeSelected">
    <i *ngIf="showSelectedDateLabels" phx-icon [phxIcon]="Bullet20Icon"></i>
    <a
      class="phx-date-picker-footer-action-btn"
      type="button"
      role="button"
      (click)="this.onReset.emit()"
      (keydown)="onKeydown($event, footerActions.RESET)"
      phxFocusableItem
    >
      {{ 'Reset' | phxTranslate }}
    </a>
  </ng-container>
</div>
